import * as z from "zod";
import { defineIntegrationSettings } from "../define-settings";

export const stripeSettings = defineIntegrationSettings({
  fields: {},
  secrets: {
    apiKey: z
      .string()
      .trim()
      .startsWith(
        "sk_",
        "Please enter a valid Stripe secret key (starts with sk_).",
      ),
  },
  connectOnly: {},
  computed: {},
});
